import React from 'react';
import EmailIntroduction from './components/EmailIntroduction';
import UpdateEmailAddress from './components/UpdateEmailAddress';

const YourEmailAddress = () => {
  return (
    <div>
      <EmailIntroduction />
      <UpdateEmailAddress />
    </div>
  );
};

export default YourEmailAddress;
